"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _reactWindow = require("react-window");

var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));

var _MonthCalendar = _interopRequireDefault(require("./MonthCalendar"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DialogContentMobile = function DialogContentMobile(_ref) {
  var fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      hoverDate = _ref.hoverDate,
      onSelectDate = _ref.onSelectDate,
      startWeekDay = _ref.startWeekDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      monthFormat = _ref.monthFormat,
      weekDayFormat = _ref.weekDayFormat,
      complsOpen = _ref.complsOpen,
      isSingle = _ref.isSingle,
      highlightToday = _ref.highlightToday;

  var _useState = (0, _react.useState)(2400),
      _useState2 = _slicedToArray(_useState, 2),
      rowCount = _useState2[0],
      setRowCount = _useState2[1];

  var minYear = minDate ? (0, _dayjs.default)(minDate).year() : 1900;
  var minMonth = minDate ? (0, _dayjs.default)(minDate).month() : 0;
  var listRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (maxDate) {
      var _minDate = minDate ? (0, _dayjs.default)(minDate) : (0, _dayjs.default)('1900-01-01');

      setRowCount((0, _dayjs.default)(maxDate).diff(_minDate, 'month') + 1);
    }
  }, [maxDate, minDate]);
  (0, _react.useEffect)(function () {
    if (listRef.current && complsOpen) {
      var date = fromDate ? (0, _dayjs.default)(fromDate) : (0, _dayjs.default)();
      var monthDiff = date.diff((0, _dayjs.default)('1900-01-01'), 'month');

      if (minDate) {
        monthDiff = date.diff((0, _dayjs.default)(minDate), 'month');
      }

      listRef.current.scrollToItem(monthDiff + 1, 'smart');
    }
  }, [complsOpen, fromDate, minDate]);

  function getMonthYearFromIndex(index) {
    var _index = index + minMonth;

    var year = minYear + Math.floor(_index / 12);
    var month = _index % 12;
    return {
      year: year,
      month: month
    };
  }

  var Row = function Row(_ref2) {
    var index = _ref2.index,
        style = _ref2.style;

    var _getMonthYearFromInde = getMonthYearFromIndex(index),
        year = _getMonthYearFromInde.year,
        month = _getMonthYearFromInde.month;

    return /*#__PURE__*/_react.default.createElement("div", {
      style: style
    }, /*#__PURE__*/_react.default.createElement(_MonthCalendar.default, {
      month: month,
      year: year,
      onSelectDate: onSelectDate,
      fromDate: fromDate,
      toDate: toDate,
      hoverDate: hoverDate,
      startWeekDay: startWeekDay,
      minDate: minDate,
      maxDate: maxDate,
      monthFormat: monthFormat,
      isSingle: isSingle,
      highlightToday: highlightToday
    }));
  };

  function getItemSize(index) {
    var _getMonthYearFromInde2 = getMonthYearFromIndex(index),
        year = _getMonthYearFromInde2.year,
        month = _getMonthYearFromInde2.month;

    var _getMonthInfo = (0, _helpers.getMonthInfo)(year, month, 'monday'),
        totalWeek = _getMonthInfo.totalWeek;

    return totalWeek.length * 48 + 34;
  }

  function renderMonthCalendars() {
    return /*#__PURE__*/_react.default.createElement(_reactVirtualizedAutoSizer.default, null, function (_ref3) {
      var height = _ref3.height,
          width = _ref3.width;
      return /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
        ref: listRef,
        width: width,
        height: height - 36,
        itemCount: rowCount,
        itemSize: getItemSize
      }, Row);
    });
  }

  function generateWeekDay() {
    var arrWeekDay = (0, _helpers.getWeekDay)(startWeekDay, weekDayFormat);
    return arrWeekDay.map(function (day, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "weekday",
        key: index
      }, day);
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "weekdays mobile"
  }, generateWeekDay()), renderMonthCalendars()));
};

DialogContentMobile.propTypes = {
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  hoverDate: _propTypes.default.instanceOf(Date),
  onSelectDate: _propTypes.default.func,
  startWeekDay: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  monthFormat: _propTypes.default.string,
  complsOpen: _propTypes.default.bool,
  isSingle: _propTypes.default.bool,
  highlightToday: _propTypes.default.bool
};
DialogContentMobile.defaultProps = {
  fromDate: null,
  toDate: null,
  hoverDate: null,
  onSelectDate: function onSelectDate() {},
  startWeekDay: null,
  minDate: null,
  maxDate: null,
  monthFormat: '',
  complsOpen: false,
  isSingle: false,
  highlightToday: false
};
var _default = DialogContentMobile;
exports.default = _default;